module.exports = __webpack_public_path__ + "static/media/main-img.03faaa7c.jpg";